import React from 'react';

import styled from 'styled-components';

export const CSSMailItemHeaderStatus = styled.div`
    width: ${(props) => props.theme.size.sm + 2}px;
    height: ${(props) => props.theme.size.sm + 2}px;
    border-radius: ${(props) => props.theme.size.sm + 2}px;
    background-color: ${(props) => props.theme.color.orange};
`;

export const WidgetEmailsImapStatus = ({ read }: { read: boolean }) => {
    return !read ? <CSSMailItemHeaderStatus></CSSMailItemHeaderStatus> : <></>;
};
